import { AbsoluteFill, Sequence, useCurrentFrame, useVideoConfig } from "remotion";
import { InvaderHookApplied } from "../hooks/InvaderHookApplied";
import { FourierHeart } from "../fourier/FourierHeart";
import { EndCta, type EndCtaProps } from "./EndCta";
import { getEndCtaDurationFrames } from "./endCtaTiming";

/** A standalone showcase; the background is not part of the reusable overlay. */
export const EndCtaDemo = ({ variant = "glass" }: EndCtaProps) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const duration = getEndCtaDurationFrames(fps);
  const rotate = frame * 1.2;
  return (
    <AbsoluteFill style={{ backgroundColor: "#080D18", color: "#F4F8FF" }}>
      <AbsoluteFill
        style={{
          background:
            "radial-gradient(ellipse at 50% 45%, rgba(56,205,189,0.15), transparent 60%)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 250,
          width: "100%",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          fontSize: 45,
          fontWeight: 700,
          letterSpacing: 7,
        }}
      >
        LOOP NIBBLE
      </div>
      <div
        style={{
          position: "absolute",
          left: 260,
          top: 600,
          width: 560,
          height: 560,
          borderRadius: 180,
          border: "6px solid rgba(56,205,189,0.68)",
          transform: "rotate(" + rotate + "deg)",
          boxShadow: "0 0 65px rgba(56,205,189,0.12)",
        }}
      />
      <Sequence from={14} durationInFrames={duration}>
        <EndCta variant={variant} />
      </Sequence>
    </AbsoluteFill>
  );
};

/** Compare with the unchanged FourierHeart composition. */
export const FourierHeartWithCta = () => {
  const { fps, durationInFrames } = useVideoConfig();
  const duration = getEndCtaDurationFrames(fps);
  const start = Math.max(0, durationInFrames - duration - Math.round(fps * 0.2));
  return (
    <AbsoluteFill>
      <FourierHeart />
      <Sequence from={start} durationInFrames={duration}>
        <EndCta variant="glass" />
      </Sequence>
    </AbsoluteFill>
  );
};

/** The existing invader hook film with an optional end CTA for comparison. */
export const InvaderHookBWithCta = () => {
  const { fps, durationInFrames } = useVideoConfig();
  const duration = getEndCtaDurationFrames(fps);
  const start = Math.max(0, durationInFrames - duration - Math.round(fps * 0.2));
  return (
    <AbsoluteFill>
      <InvaderHookApplied pattern="B" />
      <Sequence from={start} durationInFrames={duration} premountFor={fps}>
        <EndCta variant="minimal" />
      </Sequence>
    </AbsoluteFill>
  );
};
